export const HEADING_TEXT_COLORS = {
  text: "text-base",
  highlighted: "text-highlighted",
  "on-primary": "text-on-primary",
  "on-accent": "text-on-accent",
  primary: "text-primary",
  accent: "text-accent",
  success: "text-on-success",
  "on-surface-inverse": "text-on-surface-inverse",
  error: "text-on-error",
  warning: "text-on-warning",
  "gray-soft": "text-gray-soft",
} as const

export type HeadingTextColorsType = keyof typeof HEADING_TEXT_COLORS

export const HEADING_FONTS = {
  base: "font-family--base",
  brand: "font-family--brand",
} as const

export type HeadingFontsType = keyof typeof HEADING_FONTS

export const HEADING_AS = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
} as const

export type HeadingAsType = keyof typeof HEADING_AS

export const HEADING_ALIGN = {
  left: "align-left",
  center: "align-center",
  right: "align-right",
} as const

export type HeadingAlignType = keyof typeof HEADING_ALIGN
